"use client";

import { c as _c } from "react/compiler-runtime";
import { Globe2 } from "lucide-react";
import { useRouter } from "next/navigation";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/lib/components/select";
import { cn } from "@/lib/utils";
import { useI18n } from "@llmgateway/i18n/react";
import type { Locale } from "@llmgateway/i18n";
export function LanguageSwitcher(t0) {
  const $ = _c(25);
  const {
    className,
    compact: t1
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const {
    locale,
    locales,
    localeLabels,
    setLocale,
    t
  } = useI18n();
  const router = useRouter();
  let t2;
  if ($[0] !== router || $[1] !== setLocale) {
    t2 = value => {
      setLocale(value as Locale);
      router.refresh();
    };
    $[0] = router;
    $[1] = setLocale;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("language.label");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = compact ? "h-9 w-[118px]" : "h-9 w-[150px]";
  let t5;
  if ($[5] !== className || $[6] !== t4) {
    t5 = cn(t4, className);
    $[5] = className;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Globe2 className="h-4 w-4" />;
    t7 = <SelectValue />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t5) {
    t8 = <SelectTrigger aria-label={t3} className={t5}>{t6}{t7}</SelectTrigger>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== localeLabels || $[14] !== locales) {
    let t10;
    if ($[16] !== localeLabels) {
      t10 = item => <SelectItem key={item} value={item}>{localeLabels[item]}</SelectItem>;
      $[16] = localeLabels;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    t9 = locales.map(t10);
    $[13] = localeLabels;
    $[14] = locales;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <SelectContent align="end">{t9}</SelectContent>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== locale || $[21] !== t10 || $[22] !== t2 || $[23] !== t8) {
    t11 = <Select value={locale} onValueChange={t2}>{t8}{t10}</Select>;
    $[20] = locale;
    $[21] = t10;
    $[22] = t2;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}